export default `
  mutation updateCardComment(
    $id: ID!,
    $input: CardCommentInput!,
    $workflowId: String!,
    $cardId: String!
  ) {
    updateCardComment(
      id: $id,
      input: $input,
      workflowId: $workflowId,
      cardId: $cardId
    ) {
      workflowId
      cardId
      id
      text
      dateUpdated
    }
  }
`
